import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import Plyr from 'plyr';
require('../../node_modules/plyr/dist/plyr.css');

document.addEventListener('DOMContentLoaded', () => {
  gsap.registerPlugin(ScrollTrigger);

  const roboVideo = document.querySelectorAll('.js-roboVideo');

  const initRoboVideo = () => {
      for (let i = 0; i < roboVideo.length; i++) {
          const el = roboVideo[i];
          const videosAttr = el.dataset.videos;
          const customAttr = el.dataset.custom;

          if (!videosAttr || !customAttr) {
              console.warn(`Element .js-roboVideo #${i} pominięty – brak data-videos lub data-custom`, el);
              continue;
          }

          const videos = videosAttr.split(',').map(v => v.trim());
          const custom = customAttr.split(',').map(c => c.trim());
          const randomNum = Math.floor(Math.random() * (videos.length - 1) + 1); // od 1 do (length - 1)

          if (custom[randomNum]) {
              el.classList.add(custom[randomNum]);
          }

          const source = el.querySelector('source');
          if (source) {
              source.dataset.src = videos[randomNum];
          } else {
              console.warn(`Brak <source> w elemencie .js-roboVideo #${i}`, el);
          }

          const player = new Plyr(el, {
              controls: '',
              ratio: '4:3'
          });

          player.muted = true;

          ScrollTrigger.matchMedia({
              "(min-width: 769px)": () => {
                  ScrollTrigger.create({
                      trigger: el,
                      start: "top top",
                      onEnter: () => {
                          player.play();
                      }
                  });
              }
          });
      }
  };

  if (roboVideo.length > 0) {
      initRoboVideo();
  }
}, false);
